module.exports = __webpack_public_path__ + "static/ekko-app_company-logo_black-e0f56c9e4b5622899700ad4598c7f3b0.svg";